import * as RadixCheckbox from '@radix-ui/react-checkbox';
import type { ReactNode } from 'react';
import styles from './Checkbox.module.css';

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  children: ReactNode;
  id?: string;
}

export function Checkbox({ checked, onChange, children, id }: CheckboxProps): React.JSX.Element {
  return (
    <label className={styles.row} htmlFor={id}>
      <RadixCheckbox.Root
        id={id}
        className={styles.root}
        checked={checked}
        onCheckedChange={(v) => { onChange(v === true); }}
      >
        <RadixCheckbox.Indicator className={styles.indicator}>
          <CheckIcon />
        </RadixCheckbox.Indicator>
      </RadixCheckbox.Root>
      <span>{children}</span>
    </label>
  );
}

function CheckIcon(): React.JSX.Element {
  return (
    <svg width="11" height="11" viewBox="0 0 12 12" fill="none" aria-hidden="true">
      <path d="M2.5 6.5L5 9L9.5 3.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
